// extracted by mini-css-extract-plugin
export default {"container":"Team_container__hqhJu","spaces":"Team_spaces__-WDbe","heading":"Team_heading__8IwD7","content":"Team_content__Lz3XQ"};